<template>
  <div :class="['all-comment-modal', visible ? 'active' : '']">
    <div class='mask' @touchmove="stopPopup" @click="closeModal"></div>
    <div class='wrapper'>
      <div class="content animated slideInUp">
        <div class="title">
          <span>全部回复（{{comment.commentCount}}）</span>
          <i @click="closeModal"></i>
        </div>

        <div class="remark-content">
          <div class='remark-box'>
            <comment-item :item="comment" type="remark" @like="like" @reply="reply" />
          </div>
          <div class="block"></div>
          <div class="message-box" v-if="comment.messages">
            <div class="message-item" v-for="item in comment.messages" :key="item.messageId + (item.nagId || 0)">
              <comment-item :item="item" type="message" @like="like"  @reply="reply" />
            </div>
          </div>
          <div class="ui-safe-area-inset"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, getCurrentInstance, ref, watch } from 'vue'
import { exerReq } from '@/api'
import CommentItem from './comment-item.vue'
import lodashFindIndex from 'lodash/findIndex'
import cloneDeep from 'lodash/cloneDeep'
export default defineComponent({
  components: {
    CommentItem
  },
  props: {
    remarkId: {
      type: Number,
      default: 0
    },
    visible: {
      type: Boolean,
      default: false
    },
    refresh: {
      type: Boolean,
      default: false
    }
  },
  setup(props, cxt) {
    watch(() => props.visible, newVal => {
      if (newVal) {
        getRemarkList()
      }
    })
    watch(() => props.refresh, newVal => {
      if (newVal) {
        getRemarkList()
      }
    })

    const { proxy: { $showLoading, $hideLoading, $toast } } = getCurrentInstance()
    const stopPopup = event => {
      event.stopPropagation()
      event.preventDefault()
    }

    const closeModal = () => {
      cxt.emit('close', false)
    }

    const comment = ref({})
    const getRemarkList = async () => {
      $showLoading()
      const res = await exerReq.getRemarkMessageList({
        remarkId: props.remarkId
      })
      $hideLoading()
      if (res.code === 200) {
        comment.value = res.data
        cxt.emit('refresh')
      } else {
        $toast(res.message)
      }
    }

    const reply = value => {
      const options = {}
      options.userId = value.userId
      options.userName = value.userName
      options.showReplyMask = false
      options.replyType = value.replyType
      if (value.replyType === 1) {
        options.remarkId = value.remarkId
      } else if (value.replyType === 2) {
        options.messageId = value.messageId
      }
      cxt.emit('reply', options)
    }

    const like = item => {
      let data = cloneDeep(comment.value)
      if (item.messages) {
        data.approved = !item.approved;
        data.approvalCount += item.approved ? -1 : 1;
      } else {
        let ind = lodashFindIndex(data.messages, item)
        data.messages[ind].approved = !item.approved;
        data.messages[ind].approvalCount += item.approved ? -1 : 1;
      }
      comment.value = data;
    }

    return {
      stopPopup,
      closeModal,
      comment,
      like,
      reply
    }
  }
})
</script>

<style lang="scss" scoped>
.all-comment-modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 11;
  display: none;
  &.active {
    display: block;
  }
  .mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 12;
    background-color: rgba(0, 0, 0, 0.6);
  }

  .content {
    position: absolute;
    padding: 20px 0;
    width: 100%;
    top: 0.88rem;
    bottom: 0;
    background-color: #fff;
    z-index: 18;
    animation-duration: 0.4s;
    box-sizing: border-box;
    background: #FFFFFF;
    border-radius: 20px 20px 0px 0px;

    .title {
      text-align: center;
      position: relative;
      padding: 0 32px;
      height: 60px;
      line-height: 60px;
      span {
        color: #212224;
        font-size: 36px;
      }
      i {
        display: inline-block;
        width: 28px;
        height: 28px;
        background-image: url('../img/question_all_comment_close_icon.png');
        background-size: cover;
        position: absolute;
        right: 32px;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    .remark-content {
      position: absolute;
      width: 100%;
      top: 80px;
      bottom: 0;
      overflow-x: hidden;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      overflow-scrolling: touch;
    }

    .block {
      height: 16px;
      width: 100%;
      background-color: #F5F5F7;
    }

    .remark-box {
      padding: 32px 32px 0 32px;
    }

    .message-box {
      .message-item {
        padding: 32px 32px 0 32px;
        border-bottom: 2px solid #F5F5F7;
      }
    }
  }
}
</style>
